import { FC, useCallback, useEffect } from "react";
import { Outlet, useOutletContext } from "react-router";
import { CompanyAndSiteDetails } from "./types";
import { fetchBoosting } from "../store/features/campaigns/boostingRequests";
import { useRequestHandlers } from "../app/hooks/useRequestHandlers";

export const CampaignsDetailsOutlet: FC = () => {
  const { siteId, companyId, siteDetails } =
    useOutletContext<CompanyAndSiteDetails>();
  const { getApi, dispatch } = useRequestHandlers();

  const handleCampaignsDetails = useCallback(async () => {
    const api = await getApi();
    const fetchingArgs = { api, value: { companyId, siteId } };
    dispatch(fetchBoosting(fetchingArgs));
  }, [dispatch, getApi, siteId]); //companyId change leads to follow-up siteId change

  useEffect(() => {
    handleCampaignsDetails();
  }, [handleCampaignsDetails]);

  return <Outlet context={{ siteId, companyId, siteDetails }} />;
};
